import React from 'react';
import IndependentReview from './independentReview';
import PropTypes from 'prop-types';

const Specification = ({
  featuredSpec,
  independentReview,
  isRealSale,
  specification,
  vehicleSummary,
  showTabs = true,
}) => {
  return (
    <div className={`ch-container ${!showTabs && 'ch-pb--4'}`}>
      <div className={showTabs && 'tabs'}>
        {showTabs && (
          <>
            <input
              className="ch-reader"
              defaultChecked
              id="tab1"
              name="tabs"
              type="radio"
            />
            <label className="ch-tab ch-fs--2" htmlFor="tab1">
              Summary
            </label>

            <input className="ch-reader" id="tab2" name="tabs" type="radio" />
            {specification.standard && (
              <label className="ch-tab ch-fs--2" htmlFor="tab2">
                Standard
                <span className="ac-hidden--sl"> specification</span>
              </label>
            )}

            <input className="ch-reader" id="tab3" name="tabs" type="radio" />
            {specification.technical && (
              <label className="ch-tab ch-fs--2" htmlFor="tab3">
                Tech
                <span className="ac-hidden--sl">nical specification</span>
              </label>
            )}

            <input className="ch-reader" id="tab4" name="tabs" type="radio" />
            {independentReview && (
              <label className="ch-tab ch-fs--2 ac-tab--review" htmlFor="tab4">
                <span className="ac-hidden--sl">Independent </span>
                review
              </label>
            )}
          </>
        )}

        <div className={showTabs && 'tabs__panel'} id="content1">
          <div className="ch-row">
            {vehicleSummary}
            {featuredSpec}
          </div>
          {isRealSale && (
            <div className="ch-col--xs-12">
              <p className="ch-mb--0 ch-mt--2">
                This vehicle may have been advertised at the higher price for
                less than 28 days, but for a minimum of 10 days.
              </p>
            </div>
          )}
        </div>

        {specification.standard && (
          <div className="tabs__panel ac-spec__standard" id="content2">
            <h3 className="ac-spec__caplabel">Standard specification</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: specification.standard,
              }}
            />
            <small className="ac-type--book">
              The vehicle information above was correct at time of manufacture.
              Please speak to the dealership for full current specification.
            </small>
          </div>
        )}

        {specification.technical && (
          <div className="tabs__panel ac-spec__tech" id="content3">
            <h3 className="ac-spec__caplabel">Technical specification</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: specification.technical,
              }}
            />
            <small className="ac-type--book">
              The vehicle information above was correct at time of manufacture.
              Please speak to the dealership for full current specification.
            </small>
          </div>
        )}

        {independentReview && (
          <div className="tabs__panel" id="content4">
            <IndependentReview {...independentReview} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Specification;

Specification.propTypes = {
  featuredSpec: PropTypes.node,
  independentReview: PropTypes.object,
  isRealSale: PropTypes.bool,
  showTabs: PropTypes.bool,
  specification: PropTypes.object,
  vehicleSummary: PropTypes.node,
};
